import * as React from 'react'

import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'

import {
  Body,
  FieldsWrap,
  FitTitle,
  Percentage,
  Progress,
  ProgressBar,
  SurveyWrap,
  Title,
} from './styles'
import { FitSurveyItem } from './types'

export const FitSurvey: React.FC<{
  fitFields: Array<FitSurveyItem>
}> = ({ fitFields }) => {
  const {
    magnolia: {
      reviewsPage: { fitSurvey },
    },
  } = useTranslation()
  return (
    <Body>
      <Title>{fitSurvey}</Title>
      <FieldsWrap>
        {fitFields.map(field => {
          return (
            <SurveyWrap key={field.name}>
              <FitTitle>{field.name}</FitTitle>
              <ProgressBar>
                <Progress progress={field.percentage} />
              </ProgressBar>
              <Percentage>{`${field.percentage}%`}</Percentage>
            </SurveyWrap>
          )
        })}
      </FieldsWrap>
    </Body>
  )
}
